import { DialogLocal } from "@/components/Dialog";
import { Header, HeaderActionBack, HeaderActionCustomerService } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Input } from "@/components/Input";
import { Layout } from "@/components/Layout";
import { SMSButton } from "@/components/SMSButton";
import { makePlatformOnClick } from "@/components/utils";
import { cn } from "@/libs";
import { Button, Checkbox, Image } from "antd-mobile";
import { PropsWithChildren, ReactNode } from "react";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
import { SubmitBtn } from "@/components/SubmitBtn";
export const PageLogin = () => {
  const logic = useSetup();

  // 用户名输入框  logic.isUnbindMode || logic.isUserCheck
  const usernameInput = !logic.isSmsLoginMode && <Input className={cn(styles.input)} theme={logic.isUnbindMode || logic.isUserCheck ? "default" : "auth"} placeholder="请输入用户名" autocomplete="off" icon={<Icon className={cn(styles.icon)} name="username" size="24px" />} onChange={e => {
    logic.dispatch({
      type: "update_username",
      username: e.target.value
    });
  }} value={logic.state.username} />;

  // 手机号输入框
  const phoneInput = logic.isSmsLoginMode && <Input className={cn(styles.input)} theme={logic.isUnbindMode || logic.isUserCheck ? "default" : "auth"} placeholder="请输入手机号" autocomplete="off" icon={<Icon className={cn(styles.icon)} name="phone" size="24px" />} onChange={e => {
    logic.dispatch({
      type: "update_phoneNumber",
      phoneNumber: e.target.value
    });
  }} value={logic.state.phoneNumber} />;
  // 密码输入框
  const passwordInput = logic.isPasswordLoginMode && <Input className={cn(styles.input)} theme={logic.isUnbindMode || logic.isUserCheck ? "default" : "auth"} type="password" placeholder="请输入密码" icon={<Icon className={cn(styles.icon)} name="pwd" size="24px" />} onChange={e => {
    logic.dispatch({
      type: "update_password",
      password: e.target.value
    });
  }} value={logic.state.password} />;

  // 图片验证码
  const imageCodeInput = logic.isGraphicsCodeType && <Input className={cn(styles.input)} theme={logic.isUnbindMode || logic.isUserCheck ? "default" : "auth"} placeholder="请输入验证码" icon={<Icon className={cn(styles.icon)} name="code" size="24px" />} extra={<div {...makePlatformOnClick(e => {
    e.preventDefault();
    logic.flushCodeImage();
  })}>
          <Image className={cn(styles.imageCode)} src={logic.state.verifyCode} alt="code" />
        </div>} onChange={e => {
    logic.dispatch({
      type: "update_imageCode",
      imageCode: e.target.value
    });
  }} value={logic.state.imageCode} />;
  const dxCodeInput = logic.isSlideCodeType && <div style={{
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '20px',
    position: 'relative',
    zIndex: 99
  }}>
      <div id="dx_token" className={cn(styles.dx_token)}></div>
    </div>;

  // 短信验证码
  const smsCodeInput = logic.isSmsLoginMode && <Input className={cn(styles.input)} theme={logic.isUnbindMode || logic.isUserCheck ? "default" : "auth"} placeholder="请输入短信验证码" icon={<Icon className={cn(styles.icon)} name="code" size="24px" />} extra={<SMSButton sendSMS={logic.flushSMSCode} />} onChange={e => {
    logic.dispatch({
      type: "update_smsCode",
      smsCode: e.target.value
    });
  }} value={logic.state.smsCode} />;

  // 记住密码忘记密码
  const passwordSave = !logic.isUnbindMode && !logic.isUserCheck && <div className={styles.options}>
      <Checkbox icon={checked => <Icon name={checked ? "checked" : "unchecked"} size="16px" />} style={{
      "--icon-size": "16px",
      "--font-size": "12px",
      "--gap": "6px"
    }} checked={logic.rememberPassword} onChange={checked => logic.setRememberedPassword(checked)}>
        记住密码
      </Checkbox>
      <Button fill="none" className={cn(styles.forgotPassword)} onClick={async () => {
      await DialogLocal({
        theme: "warning",
        title: "找回密码，请联系客服",
        cancelText: "取消",
        onConfirm() {
          // TODO: 打开客服线
          return Promise.resolve(true);
        }
      });
    }}>
        忘记密码？
      </Button>
    </div>;
  if (logic.isUnbindMode || logic.isUserCheck) {
    return <Layout header={<Header title={logic.isUserCheck ? '登录设备验证' : "清除扫码登录设备"} leftActions={logic.isUserCheck ? <></> : <HeaderActionBack />} rightActions={<HeaderActionCustomerService />} />}>
        <div>
          <div className={styles.logo}></div>
          <UnbindFieldWrapper icon={<Icon className={cn(styles.icon)} name={logic.isSmsLoginMode ? 'phone' : 'username'} size="24px" />} label={logic.isSmsLoginMode ? "手机号" : "用户名"}>
            {usernameInput}{phoneInput}
          </UnbindFieldWrapper>

          {!logic.isSmsLoginMode ? <UnbindFieldWrapper icon={<Icon className={cn(styles.icon)} name="pwd" size="24px" />} label={"密码"}>
                {passwordInput}
              </UnbindFieldWrapper> : ''}
          
          {dxCodeInput ? dxCodeInput : <UnbindFieldWrapper icon={<Icon className={cn(styles.icon)} name="code" size="24px" />} label={"验证码"}>
                {imageCodeInput}
              </UnbindFieldWrapper>}

          {logic.isSmsLoginMode ? <UnbindFieldWrapper icon={<Icon className={cn(styles.icon)} name="code" size="24px" />} label={"短信验证码"}>
                {smsCodeInput}
              </UnbindFieldWrapper> : ''}

          <Button fill="none" block shape="rounded" className={cn(styles.submitButtonUnbind)} onClick={() => {
          logic.submit();
        }}>
            {logic.isUserCheck ? '确认' : '确认登陆'}
          </Button>
        </div>
      </Layout>;
  }
  return <div className={cn(styles.form)} data-sentry-component="PageLogin" data-sentry-source-file="index.tsx">
      {phoneInput}
      {usernameInput}
      {passwordInput}
      {imageCodeInput}
      {dxCodeInput}
      {smsCodeInput}
      {passwordSave}

      <div className={styles.switchLoginBox}>
        <Button fill="none" className={cn(styles.switchLoginMode)} onClick={() => {
        logic.dispatch({
          type: "update_mode",
          mode: logic.state.mode === 1 ? 2 : 1
        });
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {logic.contentOfSwitchLoginModeButton}
          {">"}
        </Button>
      </div>
      
      <SubmitBtn fill="none" block shape="rounded" className={cn(styles.submitButton)} onClick={() => {
      logic.submit();
    }} data-sentry-element="SubmitBtn" data-sentry-source-file="index.tsx">登录</SubmitBtn>
      
    </div>;
};
const UnbindFieldWrapper = ({
  icon,
  label,
  children
}: PropsWithChildren<{
  icon: ReactNode;
  label: string;
}>) => {
  return <div className={styles.unbindFieldWrapper} data-sentry-component="UnbindFieldWrapper" data-sentry-source-file="index.tsx">
      <div className={styles.unbindFieldTopLabel}>
        {icon}
        <span className={styles.unbindFieldLabel}>{label}</span>
      </div>
      {children}
    </div>;
};